import { Injectable, Injector } from '@angular/core';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { Vars } from '../model/vars';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';
import { ReportEmployeeAnnualIncome } from './../model/report-employee-annual-income';

@Injectable()
export class ReportEmployeeAnnualIncomeService extends BaseReportService<ReportEmployeeAnnualIncome> {

  public uri = '/api/reportEmployeeAnnualIncome/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance ReportDeductionsByEmployeeType');
  }

  buildSentence(entity?: ReportEmployeeAnnualIncome, event?: LazyLoadEvent): HttpParams {
    return null;
  }

  searchToViewTable(   fiscalYear: any,
    executingUnit: any,
    employeeType: any,
    object?: Vars
    ): Observable<any> {
      const params = new HttpParams()
        .set('fiscalYearId', fiscalYear)
        .set('euId', executingUnit)
        .set('employeeTypeId', employeeType)
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`;
        return this.httpClient.post<any>(url, object, {params}, )
        .pipe(
          tap(response => {
            this.spinnerService.hideAll();
            return response;
          })
       );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-employee-annual-income.service.ts